module.exports = __webpack_public_path__ + "img/qrcode.bd04b0a9.jpg";